import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import PageRoute from "./routes/PageRoute";

const App = () => {
  return <PageRoute />;
};

export default App;
